import { useDispatch, useSelector } from "react-redux";
import { ApiCallState, isApiCallCompletedSuccessfully, isApiCalled, isApiCallFailed, isApiCallLoading } from "src/common/ApiCall";
import { RootState } from "src/redux/store";
import { ResourcesActions } from "../../models/resources";

export function useFetchAllResourcesApiCallState(): ApiCallState {
  const { progress, error } = useSelector(
    (rootState: RootState) => rootState.resources.resourcesPEV
  );

  const dispatch = useDispatch();

  function dispatchApiCall(resetApiCall: Boolean) {
    if (!isApiCalled(progress) || resetApiCall) {
      dispatch(ResourcesActions.getAllResources());
    }
  }

  return new ApiCallState(
    isApiCalled(progress),
    isApiCallFailed(error),
    isApiCallLoading(progress),
    isApiCallCompletedSuccessfully(progress, error),
    dispatchApiCall
  );
}
